export const getClearValue = (value: string) => value?.slice(1)
